import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import firebase from "firebase/app"
import 'firebase/analytics';
import reportWebVitals from './reportWebVitals';


var firebaseConfig = {
    apiKey: "AIzaSyBA9YdDG_1L1azG0sNhzR-fVkqlV-Syg2Y",
    authDomain: "flowpro-9e1c6.firebaseapp.com",
    databaseURL: "https://flowpro-9e1c6-default-rtdb.firebaseio.com",
    projectId: "flowpro-9e1c6",
    storageBucket: "flowpro-9e1c6.appspot.com",
    messagingSenderId: "716898728830",
    appId: "1:716898728830:web:4ebf3176cef3d9b8d1912f",
    measurementId: "G-S16LCNMRY2"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();

ReactDOM.render(
    <App />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
